export default "__VITE_ASSET__Bo3hEkL8__"